module.exports = __webpack_public_path__ + "media/images/ui-icons_444444_256x240-c683ca0f77e00548e19f4ae9534cc40d.png";